module.exports = __webpack_public_path__ + "img/sent-plane@2x.57350a3c.png";